import { render, staticRenderFns } from "./ParcelServicePaymentDetail.vue?vue&type=template&id=8310eeb0&scoped=true&"
import script from "./ParcelServicePaymentDetail.vue?vue&type=script&lang=js&"
export * from "./ParcelServicePaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ParcelServicePaymentDetail.vue?vue&type=style&index=0&id=8310eeb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8310eeb0",
  null
  
)

export default component.exports